import clsx from 'clsx';
import { useCallback, useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Button, UserContext } from '@vestico/shared';

import style from './NoResultsPlaceholder.module.css';

export interface NoResultsPlaceholderProps {
  isSizeRec?: boolean;
}

export const NoResultsPlaceholder = ({ isSizeRec }: NoResultsPlaceholderProps) => {
  const { user, reloadUser } = useContext(UserContext);
  const { t } = useTranslation();

  const reset = useCallback(() => {
    if (user) {
      if (reloadUser) {
        reloadUser(true);
      }
    }
  }, [reloadUser, user]);

  return (
    <div className={clsx(style.root)}>
      <p>{isSizeRec ? t('LOC_NO_SIZE_REC_RESULTS_PLACEHOLDER_TITLE') : t('LOC_NO_RESULTS_PLACEHOLDER_TITLE')}</p>
      <p>
        <Trans t={t} i18nKey="LOC_NO_RESULTS_PLACEHOLDER_DESCRIPTION">
          Press <Button content={t('LOC_RESET_BODY_INFO_BUTTON')} onClick={reset} plain underline /> to go back.
        </Trans>
      </p>
    </div>
  );
};
